import { channel } from './channel';
import { init } from './init';
import { setNetworkStatus } from './setNetworkStatus';

export const serviceWorkerHandler = {
	init,
	setNetworkStatus,
};
export { channel };
